import { supabase } from './supabaseClient';

/**
 * Returns true if the user has tier = 'premium' in the profiles table.
 */
export async function checkPremiumStatus(email) {
  if (!email) return false;

  const { data, error } = await supabase
    .from('profiles')
    .select('tier')
    .eq('email', email)
    .maybeSingle();

  if (error) {
    console.warn('Premium check failed:', error.message);
    return false;
  }

  return data?.tier === 'premium';
}

/**
 * Returns the current user's profile (tier, xp, rank, dietary, theme).
 */
export async function getUserProfile(email) {
  if (!email) return null;

  const { data, error } = await supabase
    .from('profiles')
    .select('tier, xp_points, rank, dietary, theme_accent')
    .eq('email', email)
    .maybeSingle();

  if (error) {
    console.warn('Profile fetch failed:', error.message);
    return null;
  }

  return data;
}
